var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarteBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H1C0.447715 0 0 0.447715 0 1V12.5556C0 13.4507 1.08587 13.895 1.71326 13.2565L4.86324 10.051C5.25953 9.6477 5.91108 9.65291 6.30088 10.0625L9.27562 13.1881C9.89807 13.8422 11 13.4016 11 12.4987V1C11 0.447715 10.5523 0 10 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.749 2.009H15.105V0.365002C15.105 0.268198 15.0665 0.175358 14.998 0.106907C14.9296 0.0384561 14.8368 0 14.74 0H14.374C14.2772 0 14.1844 0.0384561 14.116 0.106907C14.0475 0.175358 14.009 0.268198 14.009 0.365002V2.009H12.365C12.2682 2.009 12.1754 2.04745 12.1069 2.11591C12.0385 2.18436 12 2.2772 12 2.374V2.739C12 2.941 12.164 3.105 12.365 3.105H14.009V4.748C14.009 4.95 14.173 5.114 14.374 5.114H14.74C14.788 5.114 14.8355 5.10453 14.8799 5.08612C14.9242 5.06772 14.9645 5.04074 14.9984 5.00674C15.0323 4.97274 15.0592 4.93238 15.0775 4.88799C15.0958 4.84359 15.1051 4.79602 15.105 4.748V3.105H16.749C16.797 3.105 16.8446 3.09553 16.8889 3.07712C16.9333 3.05872 16.9735 3.03174 17.0074 2.99774C17.0414 2.96374 17.0683 2.92339 17.0865 2.87899C17.1048 2.83459 17.1141 2.78701 17.114 2.739V2.374C17.114 2.2772 17.0755 2.18436 17.0071 2.11591C16.9386 2.04745 16.8458 2.009 16.749 2.009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteBannerIcon);
export default __webpack_public_path__ + "static/media/CarteBannerIcon.eeee7b795b280a845bcd65cef37fa1a2.svg";
export { ForwardRef as ReactComponent };